import { fetchApi } from '@/lib/api';

/**
 * The phone app's push notifications (/api/me/push-device, T-45): which phones get the signed-in
 * person's notifications. Only the page inside the app calls these (lib/native-push.ts).
 */

export type PushPlatform = 'ios' | 'android';

export function registerPushDevice(token: string, platform: PushPlatform, signal?: AbortSignal) {
  return fetchApi<{ ok: true }>('/me/push-device', {
    method: 'PUT',
    body: JSON.stringify({ token, platform }),
    signal,
  });
}

export function removePushDevice(token: string, signal?: AbortSignal) {
  return fetchApi<{ ok: true }>('/me/push-device', {
    method: 'DELETE',
    body: JSON.stringify({ token }),
    signal,
  });
}
